import store from "Public/store";
import { PERMISSIONS_GET } from "Public/store/modules/permissions";

export const checkPermission = (value) =>
  store.getters[PERMISSIONS_GET].includes(value);
